import React from 'react';
import { MainLayout, LayoutProps } from './layout';
import Banner from '../banner';
import RichText from '../rich-text';

interface BannerLayoutProps extends LayoutProps {
	title?: string;
}

export const BannerLayout: React.FC<BannerLayoutProps> = ({
	children,
	mlrVersion,
	title,
	label
}) => {
	const TitleBanner = ({ bannerTitle = '' }: { bannerTitle?: string }) => {
		//PLEASE DO NOT MOVE THIS COMPONENT FROM HERE. SEE https://novartisdevelop.atlassian.net/browse/LEAP-38882
		return (
			<h1 id="banner-title-content">
				<RichText html={bannerTitle} />
			</h1>
		);
	};
	return (
		<MainLayout 
			label={label} 
			mlrVersion={mlrVersion}
		>
			<Banner>
				<TitleBanner bannerTitle={title} />
			</Banner>
			<div className="max-w-6xl mx-auto px-6 pt-3.5 pb-16 md:pt-12 md:pb-24 lg:px-2 flex flex-col gap-y-12 lg:gap-y-1.5">
				{children}
			</div>
		</MainLayout>
	);
};
